import { connect } from 'react-redux'
import * as processAction from '../../../process/state/instance-detail/action'
import * as processSelector from '../../../process/state/instance-detail/selector'
import PreTreatmentReasonWidget from './PreTreatmentReasonWidget'


const mapStateToProps = (state, props) => {
    return {
        context: processSelector.selectProcessContext(state),
        taskName: props.taskName,
    }
}

const mapDispatchToProps = {
    changeProcessContext: processAction.changeProcessContext,
    saveProcessContext: processAction.saveProcessContext,
}

export default connect(mapStateToProps, mapDispatchToProps)(PreTreatmentReasonWidget)



// WEBPACK FOOTER //
// ./src/modules/sales-order/component/task-widget/PreTreatmentReasonWidgetContainer.js